import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import { productImageUrl } from "config/images.js";
import recordId from "../recordId.js";

const useStyles = makeStyles(styles);

/**
 * Product identification, set as the masthead of a register entry.
 *
 * Deliberately carries no score badge, no price and no link to the licensee's
 * shop: B-01 §28.2 keeps the QR journey off the licensee's commercial
 * surface, and §7 says the mark implies no quality rank.
 *
 * The record id appears here on desktop, where there is a meta row to hold it,
 * and inside the seal on a phone, where there is not. One place per width.
 */
export default function ProductHeroSection({ t, product }) {
  const classes = useStyles();

  const updated = product.updated
    ? new Date(product.updated).toLocaleDateString(t.dateLocale)
    : null;

  const photo = (
    <img
      className={classes.productPhotoImg}
      src={productImageUrl(product.imageName)}
      alt={product.name}
    />
  );

  return (
    <div className={classes.band}>
      <div className={classes.inner}>
        <div className={classes.masthead}>
          <div className={classes.mastheadText}>
            <div className={classes.eyebrow}>
              <span className={classes.eyebrowRule} />
              <span className={classes.eyebrowText}>{t.eyebrowRegistry}</span>
            </div>

            <h1 className={classes.productName}>{product.name}</h1>

            <div className={classes.identityRow}>
              <div className={classes.productPhoto}>{photo}</div>
              <div className={classes.identityMeta}>
                {product.manufacturerName && (
                  <div className={classes.metaBlock}>
                    <span className={classes.metaLabel}>
                      {t.heroManufacturer}
                    </span>
                    <p className={classes.metaValue}>
                      {product.manufacturerName}
                    </p>
                  </div>
                )}
                {updated && (
                  <div className={classes.metaBlock}>
                    <span className={classes.metaLabel}>{t.heroUpdated}</span>
                    <p className={classes.metaValueMono}>{updated}</p>
                  </div>
                )}
              </div>
            </div>

            <div className={classes.metaRow}>
              {product.manufacturerName && (
                <div
                  className={classes.metaRowBlock}
                  style={{ width: "220px" }}
                >
                  <span className={classes.metaLabel}>
                    {t.heroManufacturer}
                  </span>
                  <p className={classes.metaRowValue}>
                    {product.manufacturerName}
                  </p>
                </div>
              )}
              {updated && (
                <div
                  className={classes.metaRowBlock}
                  style={{ width: "180px" }}
                >
                  <span className={classes.metaLabel}>{t.heroUpdated}</span>
                  <p className={classes.metaRowValueMono}>{updated}</p>
                </div>
              )}
              <div className={classes.metaRowBlock} style={{ minWidth: 0 }}>
                <span className={classes.metaLabel}>{t.heroAuthId}</span>
                <p className={classes.metaRowValueMono}>{recordId(product)}</p>
              </div>
            </div>
          </div>

          <div className={classes.productPhotoDesktop}>{photo}</div>
        </div>
      </div>
    </div>
  );
}
